import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../../services/apiService";

const ADMIN_FLOW_SLICE_NAME = "adminFlow";
const adminThunkActions = {
  fileUploadType: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/fileUploadType`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.fileUploadType(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  fileUpload: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/fileUploadType`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.uploadCSV(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  verticalList: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/verticalList`,
    async (reportId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.verticalList(reportId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportFilterList: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/reportFilterList`,
    async (reportId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportFilterList(reportId);
        const response = JSON.parse(apiResponse?.data)?.data.filters || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  roleCreate: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/roleCreate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.roleCreate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  userCreate: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/userCreate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.userCreate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  userUpdate: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/userUpdate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.userUpdate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  businessCreate: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/businessCreate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.businessCreate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  globalRoleList: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/globalRoleList`,
    async (businessId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.globalRoleList(businessId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  roleList: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/roleList`,
    async (businessId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.roleList(businessId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  userSearch: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/userSearch`,
    async (searchText, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.userSearch(searchText);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),

  filterValueOptions: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/filterValueOptions`,
    async (businessId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.filterValueOptions(businessId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  childFilterValueOptions: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/childFilterValueOptions`,
    async (filterId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.childFilterValueOptions(filterId);
        const response = JSON.parse(apiResponse?.data)?.data.values || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  accessManage: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/accessManage`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.accessManage(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  businessDelete: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/businessDelete`,
    async (businessId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.businessDelete(businessId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  dashboardDelete: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/dashboardDelete`,
    async (dashboardId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.dashboardDelete(dashboardId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  filterDelete: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/filterDelete`,
    async (filterId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.filterDelete(filterId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  dashboardGroupDelete: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/dashboardDelete`,
    async (dashboardGroupId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.dashboardGroupDelete(
          dashboardGroupId
        );
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportDelete: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/dashboardDelete`,
    async (reportId, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportDelete(reportId);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  filterCreate: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/filterCreate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.filterCreate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  filterUpdate: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/filterUpdate`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.filterUpdate(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  mapFilterToReport: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/mapFilterToReport`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.mapFilterToReport(payload);
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  reportList: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/reportList`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.reportList();
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
  entityTypeList: createAsyncThunk(
    `${ADMIN_FLOW_SLICE_NAME}/entityTypeList`,
    async (payload, { rejectWithValue, dispatch }) => {
      try {
        const apiResponse = await apiService.entityTypeList();
        const response = JSON.parse(apiResponse?.data)?.data || {};
        return response || {};
      } catch (err) {
        return rejectWithValue("Login failed! Please try again");
      }
    }
  ),
};

export default adminThunkActions;
